export default __webpack_public_path__ + "static/media/about.ee0ab080.jpg";